export default "__VITE_ASSET__B53FwfJD__"